module.exports = __webpack_public_path__ + "img/0Q3A7263_L_Black.0c2d9eb8.jpg";